/**
 * Created by jv on 23/12/2016.
 */
//Styles
//require("bootstrap-loader"); // Using this module makes it so bootstrap isn't in a separate css file, it puts it as a style element AFTER all the other css files which makes it so you can't override anything anymore. Worked in development but not in test/production
require("Libs/bootstrap/bootstrap");
require("Libs/fontawesome/css/all.min.css"); // needed for 'icon-ios' (\F370)
require("Libs/fontawesome/font-awesome.min.css"); // 'old' icons which are different/pro in de 5.x version :(
require("Styles/global.scss");

require("babel-polyfill");
// require("script-loader!Sources/misc/google-analytics");
const CookieConsentController = require("Sources/services/cookieconsent-controller");
const LanguageManager = require("Sources/services/languagemanager");
const utils = require("Sources/utils/utils");
const StorageController = require("Sources/services/storage-controller");
const ModalDialog = require("Sources/utils/modal");
const User = require("Sources/models/user");
// Contains jQuery plugin so init this in the shared
require("Sources/components/input-spinner");

// These libs aren't nice and put themselves in window instead of being able to be required into a variable
// prepend the JS files with 'script-loader?' to require them like they were added with ordinary <script> tags
// https://webpack.github.io/docs/shimming-modules.html
require("script-loader?Modernizr!Libs/Modernizr/modernizr-custom");

var shared = {};

(function(Shared)
{
  Shared.defaultLocale = "nl-BE";

  LanguageManager.onInitGlobal = function()
  {
    try
    {
      /*cookieconsent.initialise({
        palette: {
          popup: {
            background: "#222222",
            text: "#ffffff"
          },
          button: {
            background: "#28aae1",
            text: "#ffffff"
          }
        },
        theme: "classic",
        content: {
          message: LanguageManager.getValueForKey("cookies.message"),
          dismiss: LanguageManager.getValueForKey("cookies.button.text"),
          link: LanguageManager.getValueForKey("cookies.link.text"),
          href: LanguageManager.getValueForKey("cookies.link")
        }
      });*/
      CookieConsentController.initialize();
    }
    catch(e)
    {
      console.error(e);
    }
  };

  Shared.isOutdated = function()
  {
    return !Modernizr.filereader;
  };

  Shared.getLocaleFromPath = function()
  {
    return utils.getPathSection(1);
  };

  Shared.getLocaleFromCookie = function()
  {
    return utils.readCookie("my.fundels.com.locale");
  };

  Shared.getUserProfile = function()
  {
    var tmpUser = StorageController.getFromLocal(StorageController.keys.LOGGED_IN_USER);
    return utils.isNotNull(tmpUser) ? new User(tmpUser) : null;
  };

  Shared.setNavigationHighlight = function(link)
  {
    var navbar = $("#navbar .nav.navbar-nav");

    navbar.find("> li").removeClass("active");

    switch(link)
    {
      case "myfundels-products":
        navbar.find("a[href='/products'],a[href='/products']").parent().addClass("active");
        break;
      case "myfundels-orders":
        navbar.find("a[href='/orders']").parent().addClass("active");
        break;
      case "myfundels-help":
        navbar.find("a[href='/help']").parent().addClass("active");
        break;
      case "store-info":
        navbar.find("a[href='/store/info']").parent().addClass("active");
        break;
      case "store-catalog":
        navbar.find("a[href='/store/catalog']").parent().addClass("active");
        break;
      default:
        break;
    }
  };

  Shared.setPageProperties = function()
  {
    try
    {
      var user = shared.getUserProfile();

      if(utils.isNotNull(user))
      {
        $("#user-name-navbar").text(user.displayName);

        if(user.type === "bibnet")
        {
          // $("#account-nav-link").addClass("nav-item-hidden");
          $("#account-nav-link").remove();
        }
      }
      else
      {
        // added for validate-ticket page: logged in user must be visible on the page, but page is not secure (can be viewed when not logged in)
        $("#user-name-navbar").text("");
        $(".dropdown.profile-menu").hide();
      }

      var locale = shared.getLocaleFromCookie();

      if(utils.isNull(locale)) locale = shared.getLocaleFromPath();
      if(utils.isNull(locale)) locale = "nl_BE";

      var isAdminPath = utils.getPathSection(2) === "admin";
      if(utils.isNotNull(user) && user.isAdmin && !isAdminPath && !$("a[href='/admin']").length)
      {
        $("#navbar .nav.navbar-nav").first().append("<li class='divider'><a href='/admin' data-localize='navigation.admin'></a></li>")
      }

      locale = locale.split("_");
      var languageCode = locale[0];
      var countryCode = locale[1];
      $("#locale-selector-flag").addClass("flag-" + countryCode.toLowerCase());
      $("#locale-selector-name").text(languageCode.toUpperCase());
    }
    catch(e)
    {
      console.error(e);
    }
  };

  Shared.Dialog = ModalDialog;
}(shared));

shared.setPageProperties();

if(shared.isOutdated())
{
  utils.devLog("Browser is outdated, redirecting to /outdated");
  utils.redirect("/outdated");
}

// if(__DEVELOPMENT__)
// {
//   // __DEVELOPMENT__ is automatically set to false in production builds
//   // If development --> expose to window
//   window.dev = require("Sources/misc/dev");
//   window.shared = shared;
// }

module.exports = shared;



// WEBPACK FOOTER //
// ./app/js/shared.js